export default {
    PADRAO: 1,
    EM_BRANCO: 2,
    PERIODO_MANHA: 3,
    PERIODO_TARDE: 4,
    PERIODO_NOITE: 5,
    QUANTIDADE_HORAS: 6,
}
